const body = {
  actural_date: '',
  actural_num: '',
  actural_unit: '支',
  note: '',
};
export default body;
